module.exports = __webpack_public_path__ + "static/media/Shake_hand.1cbc9b5f.png";